import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import './App.css';
import { Container, Row, Col } from 'react-bootstrap';
import {
  BrowserRouter,
  Routes,
  Route,
  useParams, useLocation
} from "react-router-dom";
import Header from './components/Header.js';
import Footer from './components/Footer.js';
import Dashboard from './components/dashboard/Dashboard.js';
// import StockQuote from './components/quote/StockQuote.js';
// import News from './components/news/News';
import PrivacyPolicy from './components/privacy/PrivacyPolicy';
import Contact from './components/contact/Contact';
import InsiderTradingWrap from './components/insider/InsiderTradingWrap';
import ScreenerWrap from './components/screener/ScreenWrap';
import {Helmet} from "react-helmet";
import AlgoTradeWrap from './components/algotrade/AlgoTradeWrap';
import IndexesWrap from './components/indexes/IndexesWrap';
import CryptoWrap from './components/crypto/CryptoWrap';
// import AlgoTradeWrapOthers from './components/algotrade/AlgoTradeWrapOthers';
import ForexWrap from './components/forex/ForexWrap';
import CommodityWrap from './components/commodity/CommodityWrap';
import EtfWrap from './components/etf/EtfWrap';
import MutualFundWrap from './components/mutualfund/MutualFundWrap';
import IPOCalenderWrap from './components/ipocalender/IPOCalenderWrap';
import EarningReleaseWrap from './components/earningrelease/EarningReleaseWrap';
import EconomicCalenderWrap from './components/economicCalender/EconomicCalenderWrap';
import StockDividendCalenderWrap from './components/stockdividendCalender/StockDividendCalenderWrap';
import ATSWrap from './components/ats/ATSWrap';
import StockEarningSurprises from './components/quote/StockEarningSurprises';
import StockGrade from './components/quote/StockGrade';
import InstitutionalHolder from './components/dashboard/InstitutionalHolder';
import StockInsiderTrading from './components/quote/StockInsiderTrading';
import SpecificStockNewsFull from './components/quote/SpecificStockNewsFull';
import ATSSelectedStockListDisplay from './components/ats/ATSSelectedStockListDisplay';
import AllStockNewsFull from './components/news/AllStockNewsFull';
import GeneralWrap from './components/general/GeneralWrap';
import AllChartAlgoDisplay from './components/algotrade/AllChartAlgoDisplay';
import HorizontalScroll from './components/dashboard/HorizontalScroll';
import {callService} from './service/PrePostService';
import MapsWrap from './components/maps/MapsWrap';
import Sp500MapsWrap from './components/sp500Maps/MapsWrap';
import GroupsWrap from './components/groups/GroupsWrap';
import SignupWrap from './components/signup/SignupWrap';
import SigninWrap from './components/signup/SigninWrap';
import ConfirmUserIdWrap from './components/signup/ConfirmUserIdWrap';
import UserSettingsWrap from './components/user/UserSettingsWrap';
import PortfolioWrap from './components/portfolio/PortfolioWrap';
import UserNotificationsWrap from './components/userNotifications/UserNotificationsWrap';
import NewsKeywordSettingsWrap from './components/userNewsKeywordSearch/NewsKeywordSettingsWrap';
import PortfolioAverageWrap from './components/portfolioAverage/PortfolioAverageWrap';
//import Ad from './components/Ad';
import StockPriceTarget from './components/quote/StockPriceTarget';
import StockUpgradeDowngrade from './components/upgradeDowngrade/StockUpgradeDowngrade';
import StockSenateTrading from './components/senateTrading/StockSenateTrading';
import StockUpgradeDowngradeWrap from './components/upgradeDowngrade/StockUpgradeDowngradeWrap';
import StockSenateTradingWrap from './components/senateTrading/StockSenateTradingWrap';

// const StockQuoteWrap = () => {
//   const { symbol } = useParams();
//   console.log('params', symbol, useParams());
//   return <StockQuote symbol={symbol.toUpperCase()} />;
// };

const AlgoTradeForParamWrap = () => {
  const { symbol } = useParams();
  console.log('params', symbol, useParams());
  if (!symbol.match(/^[A-Za-z0-9^.=-]+$/)){
    console.log('Contains invalid character');
    return <Dashboard />
  }
  return <AlgoTradeWrap symbol={symbol.toUpperCase()} exchange={true}/>;
};

const AlgoTradeOthersForParamWrap = () => {
  const { symbol } = useParams();
  console.log('params', symbol, useParams());
  if (!symbol.match(/^[A-Za-z0-9^.=-]+$/)){
    console.log('Contains invalid character');
    return <Dashboard />
  }
  return <AlgoTradeWrap symbol={symbol.toUpperCase()} exchange={false}/>;
};

const ScreenWrapParamWrap = () => {
  return <ScreenerWrap {...useParams()}/>;
};

const ATSWrapParamWrap = () => {
  return <ATSWrap {...useParams()}/>;
};

const StockEarningSurprisesParamWrap = () => {
  return <StockEarningSurprises {...useParams()}/>;
};

const StockGradeParamWrap = () => {
  return <StockGrade {...useParams()}/>;
};

const StockPriceTargetParamWrap = () => {
  return <StockPriceTarget {...useParams()}/>;
};

const StockUpgradeDowngradeParamWrap = () => {
  return <StockUpgradeDowngrade {...useParams()}/>;
};

const StockSenateTradingParamWrap = () => {
  return <StockSenateTrading {...useParams()}/>;
};

const InstitutionalHolderParamWrap = () => {
  return <InstitutionalHolder {...useParams()}/>;
};

const StockInsiderTradingParamWrap = () => {
  return <StockInsiderTrading {...useParams()}/>;
};

const SpecificStockNewsFullParamWrap = () => {
  return <SpecificStockNewsFull {...useParams()}/>;
};


const HorizontalScrollWrap = () => {
  //let curLocation = this.context.router.getCurrentLocation().pathname;
  const location = useLocation();
  console.log('Curlocation', location);
  if (location !== undefined && location.pathname !== undefined && location.pathname === '/'){
    return <HorizontalScroll/>;
  } else{
    return <></>;
  }
};


class App extends Component {
  componentDidMount() {
    callService();
  }

  render() {
    return (
      <div className="App">
        <Helmet>
          <meta charSet="utf-8" />
          <link rel="canonical" href="https://www.vizfm.com" />
          <title>Financial Market Visualization</title>
          <meta name="description" content="Stock Charts, Algorithmic trading, Technical Indicators" />
        </Helmet>

        <Container fluid className="p-0">
          {/* <BrowserRouter basename={"/vizapp/"}>  */}
          <BrowserRouter>
            <Row>
              <Col><Header /></Col>
            </Row>
            {/* <Row style={{backgroundColor: 'red',height:'100px'}}>
              1<br/>
              <Ad />
            </Row> */}
            <Row>
              <HorizontalScrollWrap />
            </Row>
            <Row className="justify-content-md-center">
              {/* <Col> */}
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  {/* <Route path="/quote/:symbol" element={<StockQuoteWrap />} /> */}
                  <Route path="/quote/:symbol" element={<AlgoTradeForParamWrap />} />
                  <Route path="/news" element={<AllStockNewsFull />} />
                  <Route path="/news/:symbol" element={<SpecificStockNewsFullParamWrap />} />
                  <Route path="/insider" element={<InsiderTradingWrap />} />
                  <Route path="/ipoCalender" element={<IPOCalenderWrap />} />
                  <Route path="/earningRelease" element={<EarningReleaseWrap />} />       
                  <Route path="/economicCalender" element={<EconomicCalenderWrap />} />       
                  <Route path="/stockDividend" element={<StockDividendCalenderWrap />} />           
                  <Route path="/chart/:symbol" element={<AlgoTradeForParamWrap />} />
                  <Route path="/indices" element={<IndexesWrap/>} />
                  <Route path='/crypto' element={<CryptoWrap />} />
                  <Route path='/crypto/chart/:symbol' element={<AlgoTradeOthersForParamWrap />} />
                  <Route path='/forex' element={<ForexWrap />} />
                  <Route path='/forex/chart/:symbol' element={<AlgoTradeOthersForParamWrap />} />
                  <Route path='/commodity' element={<CommodityWrap />} />
                  <Route path='/commodity/chart/:symbol' element={<AlgoTradeOthersForParamWrap />} />  
                  <Route path='/etf' element={<EtfWrap />} />
                  <Route path='/etf/chart/:symbol' element={<AlgoTradeForParamWrap />} />     
                  <Route path='/mutualfund' element={<MutualFundWrap />} />
                  <Route path='/mutualfund/chart/:symbol' element={<AlgoTradeForParamWrap />} /> 
                  <Route path='/futures/chart/:symbol' element={<AlgoTradeOthersForParamWrap />} /> 
                  <Route path='/ats' element={<ATSWrapParamWrap />} />       
                  <Route path='/ats/:symbol' element={<ATSSelectedStockListDisplay />} />                                      
                  <Route path="/privacy" element={<PrivacyPolicy />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/screener" element={<ScreenWrapParamWrap />} />
                  <Route path="/screener/country/:country/sector/:sector" element={<ScreenWrapParamWrap />} />
                  <Route path="/earningSurprises/:symbol" element={<StockEarningSurprisesParamWrap />} />
                  <Route path="/stockGrade/:symbol" element={<StockGradeParamWrap />} />
                  <Route path="/stockPriceTarget/:symbol" element={<StockPriceTargetParamWrap />} />
                  <Route path="/stockUpgradeDowngrade/:symbol" element={<StockUpgradeDowngradeParamWrap />} />
                  <Route path="/upgradeDowngrade" element={<StockUpgradeDowngradeWrap />} />
                  <Route path="/stockSenateTrading/:symbol" element={<StockSenateTradingParamWrap />} />
                  <Route path="/senateTrading" element={<StockSenateTradingWrap />} />
                  <Route path="/institutionalHolder/:symbol" element={<InstitutionalHolderParamWrap />} />
                  <Route path="/insiderTrading/:symbol" element={<StockInsiderTradingParamWrap />} />
                  <Route path="/stocks/gainers" element={<GeneralWrap option={'gainers'}/>} />
                  <Route path="/stocks/loosers" element={<GeneralWrap option={'loosers'}/>} />
                  <Route path="/stocks/active" element={<GeneralWrap option={'active'}/>} />
                  <Route path="/stocks/markets" element={<GeneralWrap option={'gainers'}/>} />
                  <Route path="/stocks/newHigh" element={<GeneralWrap option={'newHigh'}/>} />
                  <Route path="/stocks/new52High" element={<GeneralWrap option={'new52High'}/>} />
                  <Route path="/stocks/overBought" element={<GeneralWrap option={'overBought'}/>} />
                  <Route path="/stocks/newLow" element={<GeneralWrap option={'newLow'}/>} />
                  <Route path="/stocks/new52Low" element={<GeneralWrap option={'new52Low'}/>} />
                  <Route path="/stocks/overSold" element={<GeneralWrap option={'overSold'}/>} />
                  <Route path="/stocks/unusualVolume" element={<GeneralWrap option={'unusualVolume'}/>} />
                  <Route path="/stocks/mostVolatile" element={<GeneralWrap option={'mostVolatile'}/>} />
                  <Route path="/algoBacktestResult" element={<AllChartAlgoDisplay/>} />
                  <Route path="/usSectorHeatmap" element={<MapsWrap/>} />
                  <Route path="/sp500HeatMap" element={<Sp500MapsWrap/>} />
                  <Route path="/performance" element={<GroupsWrap/>} />
                  <Route path="/signup" element={<SignupWrap/>} />
                  <Route path="/signin" element={<SigninWrap/>} />
                  <Route path="/confirmUserId/email/:emailId/hash/:hashPassword" element={<ConfirmUserIdWrap/>} />
                  <Route path="/settings" element={<UserSettingsWrap/>} />
                  {/* <Route path="/portfolio" element={<PortfolioWrap/>} /> */}
                  <Route path="/notifications" element={<UserNotificationsWrap/>} />
                  <Route path="/news-keyword-search-alert" element={<NewsKeywordSettingsWrap/>} />
                  <Route path="/portfolio" element={<PortfolioAverageWrap/>} />

                  <Route path="*"
                    element={
                      // <main style={{ padding: "1rem" }}>
                      //   <p>There's nothing here!</p>
                      // </main>
                      <Dashboard />
                    }
                  />
                </Routes>
              {/* </Col> */}
            </Row>
            <Row className="justify-content-md-center">
              <Col className="justify-content-md-center"><Footer /></Col>
            </Row>
          </BrowserRouter>
        </Container>
      </div >
    );
  }
}

export default App;
